import React, { useMemo, useState } from "react";
import { ComposableMap, Geographies, Geography, Marker, ZoomableGroup } from "react-simple-maps";

const geoUrl = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

export default function MapView(selectedCities) {
  const [position, setPosition] = useState({
    coordinates: [0, 20],
    zoom: 1
  });

  const uniqueCities = useMemo(() => {
    const seen = new Set();
    return selectedCities.regions.filter(c => {
      const key = `${c.city}-${c.lat}-${c.lng}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }, [selectedCities]);

  const handleMoveEnd = (position) => {
    setPosition(position);
  };

  return (
    <div style={{ position: "relative", background: "#e6e6e6" }}>

      {/* Zoom buttons */}
      <div
        style={{
          position: "absolute",
          top: 20,
          left: 20,
          zIndex: 10,
          display: "flex",
          flexDirection: "column",
          gap: 10
        }}
      >
      </div>

      <ComposableMap
        projection="geoEqualEarth"
        projectionConfig={{ scale: 170 }}
        style={{ width: "100%", height: "350px" }}
      >
        <defs>
          <linearGradient id="mapGradient" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#2f6de1" />
            <stop offset="100%" stopColor="#4f8df7" />
          </linearGradient>
        </defs>

        <ZoomableGroup
          zoom={position.zoom}
          center={position.coordinates}
          onMoveEnd={handleMoveEnd}
        >
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map(geo => (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill="url(#mapGradient)"
                  stroke="none"
                />
              ))
            }
          </Geographies>

          {uniqueCities.map((city, i) => (
            <Marker key={i} coordinates={[city.lng, city.lat]}>
              <g>
                <circle r={5} fill="#000" stroke="#fff" strokeWidth={2} />
                <text
                  x={10}
                  y={4}
                  style={{
                    fontSize: "14px",
                    fontFamily: "Arial",
                    fill: "#000",
                    fontWeight: 600
                  }}
                >
                  {city.city}
                </text>
              </g>
            </Marker>
          ))}
        </ZoomableGroup>
      </ComposableMap>
    </div>
  );
}
